module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('profile-permission-filter-card', {
    attrs: {
      "fixedHeight": false,
      "loading-profile": _vm.loadingProfile,
      "searching": _vm.searching,
      "results": _vm.results
    },
    on: {
      "search-profile": function($event) {
        return _vm.$emit('search-profile', $event)
      },
      "display-profile": function($event) {
        return _vm.$emit('display-profile')
      }
    }
  })], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row border-bottom border-bottom white-bg dashboard-header"
  }, [_c('div', {
    staticClass: "col-lg-5 col-xl-3"
  }, [_c('h2', [_vm._v("\n        Personal Information Management\n      ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-926af554","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/permission/Dashboard.vue
// module id = 3369
// module chunks = 3